import React from 'react';

function Shield(props: React.SVGAttributes<{}>) {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect width="40" height="40" fill="white" />
            <path
                d="M25.8334 15.8333L18.3334 23.3333L15.8334 20.8333M20.0001 5L6.66675 11.6667C6.66675 20.322 11.3072 32.5163 20.0001 35C28.6929 32.5163 33.3334 20.322 33.3334 11.6667L20.0001 5Z"
                stroke="#2E2E2E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Shield;
